export default {
  content: {
    id: 'product_jp_product_condition_body_carousel_grade_c_content',
    defaultMessage:
      "There are scratches and dents visible from a distance of 50cm, but they don't affect the functionality.",
  },
  contentNew: {
    id: 'product_jp_product_condition_body_carousel_grade_c_content_new',
    defaultMessage: 'Clear signs of use (scratches and dents) present.',
  },
  pill1: {
    id: 'product_jp_product_condition_body_carousel_grade_c_pill_1',
    defaultMessage: 'Verified parts',
  },
  pill2: {
    id: 'product_jp_product_condition_body_carousel_grade_c_pill_2',
    defaultMessage: '80~100% battery capacity guarantee',
  },
  pill2New: {
    id: 'product_jp_product_condition_body_carousel_grade_c_pill_2_new',
    defaultMessage: 'Over 80% guaranteed',
  },
  grade: {
    id: 'product_jp_grade_12',
    defaultMessage: 'C grade (Fair)',
  },
}
